export default __webpack_public_path__ + "static/media/page-inbox.fdb0ca30.svg";